<template>
  <v-row no-gutters style="background-color: #0f0f0f; min-height: 100vh;">
    <v-col cols="12" lg="8" xl="6" class="mx-auto pa-8">
      
      <div class="mb-10">
        <div @click="$router.push({ name: rutaInventario('listado') })" class="back-link cursor-pointer mb-2">
          <v-icon x-small color="blue" class="mr-1">mdi-arrow-left</v-icon> VOLVER
        </div>
        <h1 class="text-h3 white--text font-weight-black">Nuevo Informe</h1>
        <p class="grey--text text-h6 mt-1">Seleccioná las categorías para el conteo del {{ moment(fechaInventario).format("LL") }}</p>
      </div>

      <v-text-field
        v-model="search"
        prepend-inner-icon="mdi-magnify"
        label="Buscar categoría..."
        dark
        filled
        rounded
        class="mb-4 yt-search-lite"
        hide-details
      ></v-text-field>

      <div class="d-flex align-center mb-4 px-4">
        <v-checkbox
          v-model="selectAll"
          @change="toggleSelectAll"
          dark
          color="white"
          label="Seleccionar todas"
          hide-details
          class="mt-0"
        ></v-checkbox>
        <v-spacer></v-spacer>
        <span class="grey--text text-caption font-weight-bold uppercase">
          {{ selectedCategorias.length }} seleccionadas de {{ categorias.length }}
        </span>
      </div>

      <div class="rounded-xl border-subtle overflow-hidden">
        <v-list dark background-color="#161616" class="pa-0">
          <template v-for="(categoria, index) in filteredCategorias">
            <v-list-item 
              :key="categoria.id"
              @click="toggleCategoria(categoria.id)"
              class="py-3 yt-list-item"
              :class="{ 'active-item': selectedCategorias.includes(categoria.id) }"
            >
              <v-list-item-action class="mr-6">
                <v-simple-checkbox
                  :value="selectedCategorias.includes(categoria.id)"
                  color="blue"
                  dark
                  @input="toggleCategoria(categoria.id)"
                ></v-simple-checkbox>
              </v-list-item-action>

              <v-list-item-content>
                <v-list-item-title class="text-h6 font-weight-bold">
                  {{ categoria.name }}
                </v-list-item-title>
                <v-list-item-subtitle class="grey--text">
                  {{ categoria.productos_count || 0 }} productos en esta categoría
                </v-list-item-subtitle>
              </v-list-item-content>

              <v-list-item-action>
                <v-icon :color="selectedCategorias.includes(categoria.id) ? 'blue' : '#333'">
                  {{ selectedCategorias.includes(categoria.id) ? 'mdi-check-circle' : 'mdi-circle-outline' }}
                </v-icon>
              </v-list-item-action>
            </v-list-item>
            <v-divider v-if="index < filteredCategorias.length - 1" :key="'div'+index" class="grey darken-4"></v-divider>
          </template>
        </v-list>
      </div>

      <v-alert
        v-if="alert.show"
        type="error"
        dark
        rounded="xl"
        class="mt-6"
        dismissible
        @input="alert.show = false"
      >
        {{ alert.text }}
      </v-alert>

      <v-btn
        x-large
        block
        rounded-pill
        color="white"
        class="black--text font-weight-black mt-8 py-8"
        elevation="0"
        :disabled="selectedCategorias.length === 0"
        @click="crearInventario"
      >
        INICIAR CONTEO AHORA
      </v-btn>

    </v-col>
  </v-row>
</template>

<script>
import inventarioMixin from "@/mixins/inventario.mixin";
import CategoriasAPI from "@/api/categorias";
import InventarioAPI from "@/api/inventario";
import moment from "moment";

export default {
  mixins: [inventarioMixin],
  data() {
    return {
      moment: moment,
      search: "",
      fechaInventario: new Date().toISOString().substr(0, 10),
      selectAll: false,
      selectedCategorias: [],
      categorias: [],
      alert: { show: false, text: "" }
    };
  },
  computed: {
    filteredCategorias() {
      return this.categorias.filter(c => 
        c.name.toLowerCase().includes(this.search.toLowerCase())
      );
    }
  },
  methods: {
    toggleCategoria(id) {
      const index = this.selectedCategorias.indexOf(id);
      if (index > -1) this.selectedCategorias.splice(index, 1);
      else this.selectedCategorias.push(id);
      this.checkSelectAllStatus();
    },
    toggleSelectAll() {
      this.selectedCategorias = this.selectAll ? this.categorias.map(c => c.id) : [];
    },
    checkSelectAllStatus() {
      this.selectAll = this.selectedCategorias.length === this.categorias.length;
    },
    crearInventario() {
      this.alert.show = false;
      InventarioAPI.create({
        fecha: this.fechaInventario,
        categorias: this.selectedCategorias,
        uuid_sucursal: this.uuidSucursalInventario,
      }).then(r => {
        this.$router.push({
          name: this.rutaInventario('iniciado'),
          params: { inventarioUuid: r.data.uuid }
        });
      }).catch(e => {
        this.alert.text = e.response?.data?.detail || "Ocurrió un error al iniciar el conteo.";
        this.alert.show = true;
      });
    },
    fetchCategorias() {
      CategoriasAPI.indexInventarioFilters(null, this.uuidSucursalInventario)
        .then(r => this.categorias = r.data);
    }
  },
  created() { this.fetchCategorias(); }
};
</script>

<style scoped>
.border-subtle { border: 1px solid #252525 !important; }
.back-link { color: #2196F3; font-size: 11px; font-weight: 800; letter-spacing: 1.5px; text-transform: uppercase; }

.yt-list-item { transition: background 0.2s; }
.yt-list-item:hover { background-color: #1f1f1f !important; cursor: pointer; }
.active-item { background-color: #1e1e1e !important; }

.yt-search-lite >>> .v-input__slot { background: #161616 !important; border: 1px solid #252525 !important; }

.uppercase { text-transform: uppercase; }
.cursor-pointer { cursor: pointer; }
</style>